/* ORJN — inject a "Search by Photo" icon next to the header search button,
 * matching the theme's boxed action style (svg-wrapper border). Mobile + desktop. */
(function () {
  var PAGE = '/pages/search-by-photo';
  var VOLT = '#c6ff2e'; // ORJN brand lime
  var SVG =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M4 8V6a2 2 0 0 1 2-2h2"/><path d="M16 4h2a2 2 0 0 1 2 2v2"/>' +
    '<path d="M20 16v2a2 2 0 0 1-2 2h-2"/><path d="M8 20H6a2 2 0 0 1-2-2v-2"/>' +
    '<circle cx="12" cy="12" r="3.4"/></svg>';

  function visible(e) { if (!e) return false; var r = e.getBoundingClientRect(); return r.width > 0 && r.height > 0 && e.offsetParent !== null; }

  function inject() {
    // There can be multiple search buttons (mobile vs desktop layouts). Target the
    // one actually VISIBLE in this viewport so the icon sits next to the real search.
    var all = [].slice.call(document.querySelectorAll('.header-actions__action[aria-label="Search"]'));
    if (!all.length) return false;
    var searchBtn = all.filter(visible)[0];
    if (!searchBtn) return false; // header not laid out yet — keep observing
    if (document.querySelector('[data-orjn-vs-launch]')) return true;
    // The search grid item (the <search-button>/.search-action wrapper, or the button).
    var gridItem = searchBtn.closest('search-button, .search-action') || searchBtn;

    var a = document.createElement('a');
    a.href = PAGE;
    a.setAttribute('aria-label', 'Search by photo');
    a.setAttribute('title', 'Search by photo');
    a.setAttribute('data-orjn-vs-launch', '');
    // Same structure/classes as a header action so the boxed .svg-wrapper style applies.
    a.className = 'button-unstyled header-actions__action';
    a.innerHTML = '<span class="svg-wrapper">' + SVG + '</span>';

    // Wrap search + our icon in ONE flex cell so we don't add a new grid item
    // (adding a grid item to the header's fixed grid scatters it). The wrapper
    // takes search's original slot and lays the two icons side by side.
    var wrap = document.createElement('div');
    wrap.setAttribute('data-orjn-vs-wrap', '');
    wrap.style.cssText = 'display:inline-flex;align-items:center;gap:10px;';
    gridItem.parentNode.insertBefore(wrap, gridItem);
    wrap.appendChild(gridItem);
    wrap.appendChild(a);
    // The theme spaces header actions with per-item horizontal margins meant for grid
    // children; inside our flex wrap those margins make the two icons overlap. Neutralize
    // them and rely on the wrap's gap for clean, equal spacing.
    gridItem.style.margin = '0';
    a.style.margin = '0';
    return true;
  }

  // Also place a scan icon INSIDE the search modal, to the left of the input.
  function injectSearchModal() {
    var inner = document.querySelector('.predictive-search-form__header-inner');
    if (!inner) return false;
    if (inner.querySelector('[data-orjn-vs-search]')) return true;
    var a = document.createElement('a');
    a.href = PAGE;
    a.setAttribute('aria-label', 'Search by image');
    a.setAttribute('title', 'Search by image');
    a.setAttribute('data-orjn-vs-search', '');
    // Brand-lime icon + small "Search by image" label, sitting left of the input.
    a.style.cssText = 'display:inline-flex;align-items:center;gap:5px;flex:0 0 auto;color:' + VOLT + ';text-decoration:none;margin-right:6px;white-space:nowrap;';
    // This label and the input compete for a 327px row on a 390px phone and read as one continuous
    // blob. The label block is tightened on three axes so the TEXT FIELD ends up wider than before,
    // not narrower: 10px -> 9px, letter-spacing .05em -> .02em, icon gap 6px -> 5px and margin-right
    // 10px -> 6px (above). The divider that separates the two lives in snippets/search-modal.liquid.
    // Measure after changing any of these — the divider's own padding is easy to spend the gain on.
    a.innerHTML = SVG + '<span style="font-size:9px;font-weight:800;letter-spacing:0.02em;text-transform:uppercase;line-height:1;">Search by image</span>';
    inner.insertBefore(a, inner.firstChild);
    // The theme's magnifier icon is absolutely positioned at the header-inner's left edge
    // and would render on top of our scan icon. Hide it — our branded scan icon takes its
    // place as the left icon of the search bar.
    var mag = inner.querySelector('.predictive-search__icon');
    if (mag) mag.style.display = 'none';
    return true;
  }

  // Header icon on load.
  if (!inject()) {
    var obs = new MutationObserver(function () { if (inject()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
    var tries = 0;
    (function attempt() { if (inject()) { obs.disconnect(); return; } if (++tries < 25) setTimeout(attempt, 300); })();
  }

  // Search-modal icon: the modal is created/shown when search opens — which differs
  // across mobile/desktop and can happen more than once. A persistent observer catches
  // it however it appears (click, keyboard, mobile drawer) and on every re-open.
  var mObs = new MutationObserver(function () {
    var inner = document.querySelector('.predictive-search-form__header-inner');
    if (inner && !inner.querySelector('[data-orjn-vs-search]')) injectSearchModal();
  });
  mObs.observe(document.documentElement, { childList: true, subtree: true });
  // Belt-and-braces: also nudge on the search button click and once on load.
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('.header-actions__action[aria-label="Search"]'))) return;
    var n = 0;
    (function t() { if (injectSearchModal()) return; if (++n < 40) setTimeout(t, 120); })();
  }, true);
  setTimeout(injectSearchModal, 1500);
})();
